/**
 * Links to a Public Page / Agreement are written into the Terms & Conditions HTML as an ordinary
 * anchor whose href is this marker. Nothing else in the editor understands the target, so the marker
 * survives copy/paste, undo and Jodit's own link dialog untouched.
 */
const DOCUMENT_HREF_PREFIX = '#succeed-doc-';

export function documentHref(templateId: string) {
  return `${DOCUMENT_HREF_PREFIX}${templateId}`;
}

/** The template id a terms link points at, or null for an ordinary link. */
export function documentIdFromHref(href?: string | null): string | null {
  if (!href || !href.startsWith(DOCUMENT_HREF_PREFIX)) return null;
  return href.slice(DOCUMENT_HREF_PREFIX.length) || null;
}

/** Every document linked from a Terms & Conditions body, in order of appearance. */
export function getLinkedDocumentIds(termsHtml?: string | null): string[] {
  if (!termsHtml) return [];
  const matches = termsHtml.match(new RegExp(`${DOCUMENT_HREF_PREFIX}[0-9a-zA-Z_-]+`, 'g')) ?? [];
  return Array.from(new Set(matches.map(m => m.slice(DOCUMENT_HREF_PREFIX.length))));
}

/**
 * Where a Terms & Conditions document link points.
 *
 * On a sent proposal each linked document has been generated server-side for that proposal (a
 * tm_agreements row with the proposal's values filled in, see ProposalDocumentService) and has its own
 * public link — that's what the customer reads before ticking the box. While there is no generated copy
 * (building a template, a draft) it falls back to the template's own preview page.
 */
export function buildDocumentUrl(params: { appId?: string | null; hash?: string | null; documentId: string }) {
  const { appId, hash, documentId } = params;
  if (!hash) return `/template-preview/${appId ?? '0'}/template/${documentId}`;
  const query = new URLSearchParams({ appId: appId ?? '0', hash }).toString();
  return `/proposal-document?q=${btoa(query)}`;
}
